{
	"message": "hello i18n !!",
	"Thinking": "思索型",
	"Active": "活動型",
	"Hardworking": "努力型",
	"Positive": "積極型",
	"SelfControl": "自制型",
	"Introversive": "内閉性",
	"Objective": "客観性",
	"Physical": "身体性",
	"Emotional": "気分性",
	"Persistency": "持続性",
	"Regulality": "規則性",
	"Competitive": "競争性",
	"SelfRespective": "自尊心",
	"Carefull": "慎重性",
	"Timid": "弱気さ",
	"input_required": "{field}は必須です",
	"input_min": "{field}は{value}以上で入力してください",
	"input_max": "{field}は{value}以下で入力してください",
	"input_email": "メールアドレスの形式が不正です"
}